"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOData__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "nounsToken_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nounsDao_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AmountExceedsBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "FailedWithdrawingETH",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSupportValue",
        type: "error",
    },
    {
        inputs: [],
        name: "MustBeNounerOrPaySufficientFee",
        type: "error",
    },
    {
        inputs: [],
        name: "MustProvideActions",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyProposerCanCreateUpdateCandidate",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposalInfoArityMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposalToUpdateMustBeUpdatable",
        type: "error",
    },
    {
        inputs: [],
        name: "SlugAlreadyUsed",
        type: "error",
    },
    {
        inputs: [],
        name: "SlugDoesNotExist",
        type: "error",
    },
    {
        inputs: [],
        name: "TooManyActions",
        type: "error",
    },
    {
        inputs: [],
        name: "UpdateProposalCandidatesOnlyWorkWithProposalsBySigs",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "CandidateFeedbackSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCreateCandidateCost",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCreateCandidateCost",
                type: "uint256",
            },
        ],
        name: "CreateCandidateCostSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldFeeRecipient",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newFeeRecipient",
                type: "address",
            },
        ],
        name: "FeeRecipientSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "FeedbackSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
        ],
        name: "ProposalCandidateCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "encodedProposalHash",
                type: "bytes32",
            },
        ],
        name: "ProposalCandidateCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "encodedProposalHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "ProposalCandidateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expirationTimestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "encodedPropHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sigDigest",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "SignatureAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldUpdateCandidateCost",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newUpdateCandidateCost",
                type: "uint256",
            },
        ],
        name: "UpdateCandidateCostSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "PRIOR_VOTES_BLOCKS_AGO",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "expirationTimestamp",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "encodedProp",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "addSignature",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
        ],
        name: "cancelProposalCandidate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "createCandidateCost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
        ],
        name: "createProposalCandidate",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "feeRecipient",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "createCandidateCost_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "updateCandidateCost_",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "feeRecipient_",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsDao",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsToken",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "propCandidates",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "sendCandidateFeedback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "sendFeedback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newCreateCandidateCost",
                type: "uint256",
            },
        ],
        name: "setCreateCandidateCost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "newFeeRecipient",
                type: "address",
            },
        ],
        name: "setFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newUpdateCandidateCost",
                type: "uint256",
            },
        ],
        name: "setUpdateCandidateCost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateCandidateCost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "updateProposalCandidate",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60e0604052306080523480156200001557600080fd5b5060405162002de938038062002de9833981016040819052620000389162000129565b600054610100900460ff168062000052575060005460ff16155b620000ba5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b600054610100900460ff16158015620000dd576000805461ffff19166101011790555b6001600160a01b0380841660a052821660c052801562000103576000805461ff00191690555b50505062000161565b80516001600160a01b03811681146200012457600080fd5b919050565b600080604083850312156200013d57600080fd5b62000148836200010c565b915062000158602084016200010c565b90509250929050565b60805160a05160c051612c2e620001bb6000396000818161034b015281816109ac0152610a6e0152600081816103d001526113c70152600081816105c1015281816106010152818161085801526108980152612c2e6000f3fe6080604052600436106101405760003560e01c8063628ff474116100b65780638da5cb5b1161006f5780638da5cb5b146103805780639e3d87cd1461039e578063ced9481f146103be578063e74b981b146103f2578063f2fde38b14610412578063ff4ca1841461043257600080fd5b8063628ff474146102d55780636549df9f146102f95780637031ba591461030f578063715018a614610324578063841de94714610339578063848ea72f1461036d57600080fd5b806338e861a01161010857806338e861a01461021757806346904840146102375780634782f7791461026f5780634f1ef2861461028f578063614ef902146102a2578063615e4ef9146102c257600080fd5b806306b88d68146101455780631fdefaab146101675780632a03c079146101875780633659cfe6146101a757806338cbe0ca146101c7575b600080fd5b34801561015157600080fd5b50610165610160366004611c42565b610452565b005b34801561017357600080fd5b50610165610182366004611c42565b6104cb565b34801561019357600080fd5b506101656101a2366004611d39565b610533565b3480156101b357600080fd5b506101656101c2366004611d9a565b6105b7565b3480156101d357600080fd5b506102026101e2366004611db7565b606760209081526000928352604080842090915290825290205460ff1681565b60405190151581526020015b60405180910390f35b34801561022357600080fd5b50610165610232366004611df4565b61067f565b34801561024357600080fd5b50606854610257906001600160a01b031681565b6040516001600160a01b03909116815260200161020e565b34801561027b57600080fd5b5061016561028a366004611db7565b610742565b61016561029d366004611e7a565b61084e565b3480156102ae57600080fd5b506101656102bd366004611ec9565b610907565b6101656102d0366004612189565b610a52565b3480156102e157600080fd5b506102eb60655481565b60405190815260200161020e565b34801561030557600080fd5b506102eb60665481565b34801561031b57600080fd5b506102eb600181565b34801561033057600080fd5b50610165610ceb565b34801561034557600080fd5b506102577f000000000000000000000000000000000000000000000000000000000000000081565b61016561037b366004612288565b610d21565b34801561038c57600080fd5b506033546001600160a01b0316610257565b3480156103aa57600080fd5b506101656103b93660046123ac565b610e68565b3480156103ca57600080fd5b506102577f000000000000000000000000000000000000000000000000000000000000000081565b3480156103fe57600080fd5b5061016561040d366004611d9a565b610f4d565b34801561041e57600080fd5b5061016561042d366004611d9a565b610fc9565b34801561043e57600080fd5b5061016561044d3660046123f6565b611061565b6033546001600160a01b031633146104855760405162461bcd60e51b815260040161047c9061244c565b60405180910390fd5b606680549082905560408051828152602081018490527fa5ff6097ec99d1e07b3a63580670fae7f549bde33491de1bd1877250d26cc34b91015b60405180910390a15050565b6033546001600160a01b031633146104f55760405162461bcd60e51b815260040161047c9061244c565b606580549082905560408051828152602081018490527f3e09bd31378b9c85b14184aa5a8cdafd32b41315a2adf5579140ccfff0aefa4791016104bf565b336000908152606760209081526040808320845185840120845290915290205460ff1661057357604051636a76632960e11b815260040160405180910390fd5b336001600160a01b03167f535f3f195da71b37d09a686916267ef7ad39d15bef95c61e85224d35f8b8fbad826040516105ac91906124d1565b60405180910390a250565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036105ff5760405162461bcd60e51b815260040161047c906124e4565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166106316110d0565b6001600160a01b0316146106575760405162461bcd60e51b815260040161047c90612530565b610660816110fe565b6040805160008082526020820190925261067c91839190611128565b50565b6001600160a01b0384166000908152606760209081526040808320865187840120845290915290205460ff166106c857604051636a76632960e11b815260040160405180910390fd5b60028260ff1611156106ed57604051634f81348960e11b815260040160405180910390fd5b836001600160a01b0316336001600160a01b03167f1e071c52ea06b433aac74cdba4ed70ff3e6635d5a6b344d654c04b4c762f054e8585856040516107349392919061257c565b60405180910390a350505050565b6033546001600160a01b0316331461076c5760405162461bcd60e51b815260040161047c9061244c565b4781111561078d576040516312d5633960e31b815260040160405180910390fd5b600080836001600160a01b03168360405160006040518083038185875af1925050503d80600081146107db576040519150601f19603f3d011682016040523d82523d6000602084013e6107e0565b606091505b5091509150816108055780604051636a30b5a560e01b815260040161047c91906124d1565b836001600160a01b03167f94b2de810873337ed265c5f8cf98c9cffefa06b8607f9a2f1fbaebdfbcfbef1c8460405161084091815260200190565b60405180910390a250505050565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036108965760405162461bcd60e51b815260040161047c906124e4565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166108c86110d0565b6001600160a01b0316146108ee5760405162461bcd60e51b815260040161047c90612530565b6108f7826110fe565b61090382826001611128565b5050565b6001600160a01b0385166000908152606760209081526040808320875188840120845290915290205460ff1661095057604051636a76632960e11b815260040160405180910390fd5b6000831561097e577fe5a9e6d2702042f3612beac0f605312204baddec2d19d1338da7e37e6c67d6ee6109a0565b7fd4eafb6bc770edecb5da52765bc3f50af948bfe1b8344cf115f8ee7fefe55ec75b905060006109d082858a7f000000000000000000000000000000000000000000000000000000000000000061126c565b90506109dd33828b611357565b6109fa57604051638baa579f60e01b815260040160405180910390fd5b8351602085012060405133917f049e3f4ea065d6c7f5c163f55c25cff7a2e7a6f7da1379f9e2a0173618d1db6891610a3f918d918d918d918d918d918a908d906125b4565b60405180910390a2505050505050505050565b8015610b6d57604051631c4e85c360e31b8152600481018290527f0000000000000000000000000000000000000000000000000000000000000000906000906001600160a01b0383169063e2742e1890602401600060405180830381865afa158015610ac2573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610aea91908101906126a6565b9050806102000151431115610b1257604051630a03350360e31b815260040160405180910390fd5b60208101516001600160a01b03163314610b3f57604051636391d6c560e01b815260040160405180910390fd5b806101e0015151600003610b66576040516314f1d23560e21b815260040160405180910390fd5b5050610ba2565b610b76336113ba565b158015610b84575060655434105b15610ba2576040516339b4a7f160e11b815260040160405180910390fd5b336000908152606760209081526040808320855186840120845290915290205460ff1615610be3576040516323a5379b60e21b815260040160405180910390fd5b610c0c60405180608001604052808981526020018881526020018781526020018681525061147a565b33600081815260676020908152604080832086518784012084528252808320805460ff1916600117905580516080810182528b81529182018a90528101889052606081018790529091610c5f918661150e565b90508115610c8c578181604051602001610c7a9291906127fe565b60405160208183030381529060405290505b610c94611769565b8051602082012060405133917f092e72bcc568a2ad800b1d7bbd7cc3f305e4a7b596092c69d10da00e38d705e691610cd9918c918c918c918c918c918c918c916128ed565b60405180910390a25050505050505050565b6033546001600160a01b03163314610d155760405162461bcd60e51b815260040161047c9061244c565b610d1f60006117e5565b565b610d2a336113ba565b158015610d38575060665434105b15610d56576040516339b4a7f160e11b815260040160405180910390fd5b336000908152606760209081526040808320865187840120845290915290205460ff16610d9657604051636a76632960e11b815260040160405180910390fd5b610dbf60405180608001604052808a81526020018981526020018881526020018781525061147a565b6000610dec3360405180608001604052808c81526020018b81526020018a8152602001898152508761150e565b90508215610e19578281604051602001610e079291906127fe565b60405160208183030381529060405290505b610e21611769565b8051602082012060405133917f918063625a303d021375548c338d007d2857e576643789b387992dcfe04449cc91610a3f918d918d918d918d918d918d918d918d9061297d565b600054610100900460ff1680610e81575060005460ff16155b610ee45760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840161047c565b600054610100900460ff16158015610f06576000805461ffff19166101011790555b610f0f856117e5565b60658490556066839055606880546001600160a01b0319166001600160a01b0384161790558015610f46576000805461ff00191690555b5050505050565b6033546001600160a01b03163314610f775760405162461bcd60e51b815260040161047c9061244c565b606880546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f15d80a013f22151bc7246e3bc132e12828cde19de98870475e3fa7084015272190600090a35050565b6033546001600160a01b03163314610ff35760405162461bcd60e51b815260040161047c9061244c565b6001600160a01b0381166110585760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161047c565b61067c816117e5565b60028260ff16111561108657604051634f81348960e11b815260040160405180910390fd5b336001600160a01b03167f66777d398af2d3ad91be043f4ee15e0058fd64a2badd9977e29334dc608bbfa68484846040516110c393929190612a26565b60405180910390a2505050565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546001600160a01b031690565b6033546001600160a01b0316331461067c5760405162461bcd60e51b815260040161047c9061244c565b60006111326110d0565b905061113d84611837565b60008351118061114a5750815b1561115b5761115984846118dc565b505b7f4910fdfa16fed3260ed0e7147f7cc6da11a60208b5b9406d12a635614ffd9143805460ff16610f4657805460ff191660011781556040516001600160a01b03831660248201526111da90869060440160408051601f198184030181529190526020810180516001600160e01b0316631b2ce7f360e11b1790526118dc565b50805460ff191681556111eb6110d0565b6001600160a01b0316826001600160a01b0316146112635760405162461bcd60e51b815260206004820152602f60248201527f45524331393637557067726164653a207570677261646520627265616b73206660448201526e75727468657220757067726164657360881b606482015260840161047c565b610f468561190a565b60008085858560405160200161128493929190612a51565b60408051808303601f190181528282528051602091820120838301835260098452684e6f756e732044414f60b81b9382019390935281517f8cad95687ba82c2ce50e74f7b754645e5117c3a5bec8151c0726d5857980a866818301527fe1dd93b3612547b4bb7c3d429f3df8508d84f5a4f63b5e2e44340b94698e6b3b818401524660608201526001600160a01b03969096166080808801919091528251808803909101815260a0870192839052805191012061190160f01b825260a286015260c2909401525050604290209392505050565b6000806000611366858561194a565b9092509050600081600481111561137f5761137f612a7e565b14801561139d5750856001600160a01b0316826001600160a01b0316145b806113ae57506113ae86868661198f565b925050505b9392505050565b6000806001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001663782d6fe1846113f8600143612aaa565b6040516001600160e01b031960e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381865afa158015611441573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114659190612abd565b6bffffffffffffffffffffffff161192915050565b602081015151815151141580611497575060408101515181515114155b806114a9575060608101515181515114155b156114c75760405163ccb0ce3f60e01b815260040160405180910390fd5b8051516000036114ea57604051630f24cd7360e01b815260040160405180910390fd5b805151600a101561067c576040516308e3b1eb60e11b815260040160405180910390fd5b606060008360400151516001600160401b0381111561152f5761152f611c5b565b604051908082528060200260200182016040528015611558578160200160208202803683370190505b50905060005b8460400151518110156115bd578460400151818151811061158157611581612aeb565b6020026020010151805190602001208282815181106115a2576115a2612aeb565b60209081029190910101526115b681612b01565b905061155e565b5060008460600151516001600160401b038111156115dd576115dd611c5b565b604051908082528060200260200182016040528015611606578160200160208202803683370190505b50905060005b85606001515181101561166b578560600151818151811061162f5761162f612aeb565b60200260200101518051906020012082828151811061165057611650612aeb565b602090810291909101015261166481612b01565b905061160c565b508451604051879161167f91602001612b1a565b6040516020818303038152906040528051906020012086602001516040516020016116aa9190612b59565b60405160208183030381529060405280519060200120846040516020016116d19190612b59565b60405160208183030381529060405280519060200120846040516020016116f89190612b59565b60408051601f1981840301815282825280516020918201208b518c8301206001600160a01b0390981691840191909152908201949094526060810192909252608082015260a081019190915260c081019190915260e001604051602081830303815290604052925050509392505050565b6068546001600160a01b0316341580159061178c57506001600160a01b03811615155b1561067c576040516001600160a01b038216903490600081818185875af1925050503d80600081146117da576040519150601f19603f3d011682016040523d82523d6000602084013e6117df565b606091505b50505050565b603380546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b803b61189b5760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201526c1bdd08184818dbdb9d1c9858dd609a1b606482015260840161047c565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc80546001600160a01b0319166001600160a01b0392909216919091179055565b60606119018383604051806060016040528060278152602001612bd260279139611a7b565b90505b92915050565b61191381611837565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b60008082516041036119805760208301516040840151606085015160001a61197487828585611b45565b94509450505050611988565b506000905060025b9250929050565b6000806000856001600160a01b0316631626ba7e60e01b86866040516024016119b9929190612b83565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b03199094169390931790925290516119f79190612b9c565b600060405180830381855afa9150503d8060008114611a32576040519150601f19603f3d011682016040523d82523d6000602084013e611a37565b606091505b5091509150818015611a4b57506020815110155b80156113ae57508051630b135d3f60e11b90611a709083016020908101908401612bb8565b149695505050505050565b6060833b611ada5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a2064656c65676174652063616c6c20746f206e6f6e2d636f6044820152651b9d1c9858dd60d21b606482015260840161047c565b600080856001600160a01b031685604051611af59190612b9c565b600060405180830381855af49150503d8060008114611b30576040519150601f19603f3d011682016040523d82523d6000602084013e611b35565b606091505b50915091506113ae828286611c09565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0831115611b7c5750600090506003611c00565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa158015611bd0573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b038116611bf957600060019250925050611c00565b9150600090505b94509492505050565b60608315611c185750816113b3565b825115611c285782518084602001fd5b8160405162461bcd60e51b815260040161047c91906124d1565b600060208284031215611c5457600080fd5b5035919050565b634e487b7160e01b600052604160045260246000fd5b60405161026081016001600160401b0381118282101715611c9457611c94611c5b565b60405290565b604051601f8201601f191681016001600160401b0381118282101715611cc257611cc2611c5b565b604052919050565b600082601f830112611cdb57600080fd5b81356001600160401b03811115611cf457611cf4611c5b565b611d07601f8201601f1916602001611c9a565b818152846020838601011115611d1c57600080fd5b816020850160208301376000918101602001919091529392505050565b600060208284031215611d4b57600080fd5b81356001600160401b03811115611d6157600080fd5b611d6d84828501611cca565b949350505050565b6001600160a01b038116811461067c57600080fd5b8035611d9581611d75565b919050565b600060208284031215611dac57600080fd5b81356113b381611d75565b60008060408385031215611dca57600080fd5b8235611dd581611d75565b946020939093013593505050565b803560ff81168114611d9557600080fd5b60008060008060808587031215611e0a57600080fd5b8435611e1581611d75565b935060208501356001600160401b0380821115611e3157600080fd5b611e3d88838901611cca565b9450611e4b60408801611de3565b93506060870135915080821115611e6157600080fd5b50611e6e87828801611cca565b91505092959194509250565b60008060408385031215611e8d57600080fd5b8235611e9881611d75565b915060208301356001600160401b03811115611eb357600080fd5b611ebf85828601611cca565b9150509250929050565b600080600080600080600060e0888a031215611ee457600080fd5b87356001600160401b0380821115611efb57600080fd5b611f078b838c01611cca565b985060208a01359750611f1c60408b01611d8a565b965060608a0135915080821115611f3257600080fd5b611f3e8b838c01611cca565b955060808a0135945060a08a0135915080821115611f5b57600080fd5b611f678b838c01611cca565b935060c08a0135915080821115611f7d57600080fd5b50611f8a8a828b01611cca565b91505092959891949750929550565b60006001600160401b03821115611fb257611fb2611c5b565b5060051b60200190565b600082601f830112611fcd57600080fd5b81356020611fe2611fdd83611f99565b611c9a565b82815260059290921b8401810191818101908684111561200157600080fd5b8286015b8481101561202557803561201881611d75565b8352918301918301612005565b509695505050505050565b600082601f83011261204157600080fd5b81356020612051611fdd83611f99565b82815260059290921b8401810191818101908684111561207057600080fd5b8286015b848110156120255780358352918301918301612074565b600082601f83011261209c57600080fd5b813560206120ac611fdd83611f99565b82815260059290921b840181019181810190868411156120cb57600080fd5b8286015b848110156120255780356001600160401b038111156120ee5760008081fd5b6120fc8986838b0101611cca565b8452509183019183016120cf565b600082601f83011261211b57600080fd5b8135602061212b611fdd83611f99565b82815260059290921b8401810191818101908684111561214a57600080fd5b8286015b848110156120255780356001600160401b0381111561216d5760008081fd5b61217b8986838b0101611cca565b84525091830191830161214e565b600080600080600080600060e0888a0312156121a457600080fd5b87356001600160401b03808211156121bb57600080fd5b6121c78b838c01611fbc565b985060208a01359150808211156121dd57600080fd5b6121e98b838c01612030565b975060408a01359150808211156121ff57600080fd5b61220b8b838c0161208b565b965060608a013591508082111561222157600080fd5b61222d8b838c0161210a565b955060808a013591508082111561224357600080fd5b61224f8b838c01611cca565b945060a08a013591508082111561226557600080fd5b506122728a828b01611cca565b92505060c0880135905092959891949750929550565b600080600080600080600080610100898b0312156122a557600080fd5b88356001600160401b03808211156122bc57600080fd5b6122c88c838d01611fbc565b995060208b01359150808211156122de57600080fd5b6122ea8c838d01612030565b985060408b013591508082111561230057600080fd5b61230c8c838d0161208b565b975060608b013591508082111561232257600080fd5b61232e8c838d0161210a565b965060808b013591508082111561234457600080fd5b6123508c838d01611cca565b955060a08b013591508082111561236657600080fd5b6123728c838d01611cca565b945060c08b0135935060e08b013591508082111561238f57600080fd5b5061239c8b828c01611cca565b9150509295985092959890939650565b600080600080608085870312156123c257600080fd5b84356123cd81611d75565b9350602085013592506040850135915060608501356123eb81611d75565b939692955090935050565b60008060006060848603121561240b57600080fd5b8335925061241b60208501611de3565b915060408401356001600160401b0381111561243657600080fd5b61244286828701611cca565b9150509250925092565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b60005b8381101561249c578181015183820152602001612484565b50506000910152565b600081518084526124bd816020860160208601612481565b601f01601f19169290920160200192915050565b60208152600061190160208301846124a5565b6020808252602c908201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060408201526b19195b1959d85d1958d85b1b60a21b606082015260800190565b6020808252602c908201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060408201526b6163746976652070726f787960a01b606082015260800190565b60608152600061258f60608301866124a5565b60ff8516602084015282810360408401526125aa81856124a5565b9695505050505050565b60006101008083526125c88184018c6124a5565b602084018b90526001600160a01b038a166040850152838103606085015290506125f281896124a5565b90508660808401528560a08401528460c084015282810360e084015261261881856124a5565b9b9a5050505050505050505050565b8051611d9581611d75565b80518015158114611d9557600080fd5b600082601f83011261265357600080fd5b81516020612663611fdd83611f99565b82815260059290921b8401810191818101908684111561268257600080fd5b8286015b8481101561202557805161269981611d75565b8352918301918301612686565b6000602082840312156126b857600080fd5b81516001600160401b03808211156126cf57600080fd5b9083019061026082860312156126e457600080fd5b6126ec611c71565b825181526126fc60208401612627565b602082015260408301516040820152606083015160608201526080830151608082015260a083015160a082015260c083015160c082015260e083015160e0820152610100808401518183015250610120808401518183015250610140612763818501612632565b90820152610160612775848201612632565b90820152610180612787848201612632565b908201526101a083810151908201526101c080840151908201526101e080840151838111156127b557600080fd5b6127c188828701612642565b91830191909152506102008381015190820152610220808401519082015261024091506127ef828401612632565b91810191909152949350505050565b82815260008251612816816020850160208701612481565b919091016020019392505050565b600081518084526020808501945080840160005b8381101561285d5781516001600160a01b031687529582019590820190600101612838565b509495945050505050565b600081518084526020808501945080840160005b8381101561285d5781518752958201959082019060010161287c565b600081518084526020808501808196508360051b8101915082860160005b858110156128e05782840389526128ce8483516124a5565b988501989350908401906001016128b6565b5091979650505050505050565b60006101008083526129018184018c612824565b90508281036020840152612915818b612868565b90508281036040840152612929818a612898565b9050828103606084015261293d8189612898565b9050828103608084015261295181886124a5565b905082810360a084015261296581876124a5565b60c0840195909552505060e001529695505050505050565b60006101208083526129918184018d612824565b905082810360208401526129a5818c612868565b905082810360408401526129b9818b612898565b905082810360608401526129cd818a612898565b905082810360808401526129e181896124a5565b905082810360a08401526129f581886124a5565b90508560c08401528460e0840152828103610100840152612a1681856124a5565b9c9b505050505050505050505050565b83815260ff83166020820152606060408201526000612a4860608301846124a5565b95945050505050565b83815260008351612a69816020850160208801612481565b60209201918201929092526040019392505050565b634e487b7160e01b600052602160045260246000fd5b634e487b7160e01b600052601160045260246000fd5b8181038181111561190457611904612a94565b600060208284031215612acf57600080fd5b81516bffffffffffffffffffffffff811681146113b357600080fd5b634e487b7160e01b600052603260045260246000fd5b600060018201612b1357612b13612a94565b5060010190565b815160009082906020808601845b83811015612b4d5781516001600160a01b031685529382019390820190600101612b28565b50929695505050505050565b815160009082906020808601845b83811015612b4d57815185529382019390820190600101612b67565b828152604060208201526000611d6d60408301846124a5565b60008251612bae818460208701612481565b9190910192915050565b600060208284031215612bca57600080fd5b505191905056fe416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a264697066735822122052cda45c904ecbdf6383c094ff610017c4108371a8aa499ece913a418511602064736f6c63430008130033";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOData__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(nounsToken_, nounsDao_, overrides) {
        return super.deploy(nounsToken_, nounsDao_, overrides || {});
    }
    getDeployTransaction(nounsToken_, nounsDao_, overrides) {
        return super.getDeployTransaction(nounsToken_, nounsDao_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOData__factory = NounsDAOData__factory;
NounsDAOData__factory.bytecode = _bytecode;
NounsDAOData__factory.abi = _abi;
